module.exports = __webpack_public_path__ + "static/img/aqzs54.ac48acbf.jpg";